document.addEventListener('DOMContentLoaded', function() {
  // Shopify money format from settings
  const MONEY_FORMAT = '';
  
  // Translations object - from window object (set in header.liquid)
  const TRANSLATIONS = window.searchTranslations;
  
  const searchToggles = document.querySelectorAll('.search-toggle');
  const searchModal = document.getElementById('search-modal');
  const searchInput = document.getElementById('search-input');
  const searchClose = document.querySelector('.search-modal__close');
  const headerBlur = document.querySelector('.header-desktop--blur');
  const searchResults = document.querySelector('.search-results');
  const initialContent = document.querySelector('.search-results__initial');
  const resultsContent = document.querySelector('.search-results__content');
  const productsContainer = document.querySelector('.search-results__products');
  const storiesContainer = document.querySelector('.search-results__stories');
  const loadingElement = document.querySelector('.search-results__loading');
  const collectionSearchUrl = document.querySelector('meta[name="collection-search-url"]').getAttribute('content');

  // Animation duration for modal transitions (in ms)
  const MODAL_TRANSITION_DURATION = 300;
  
  // Add a container for no results message that won't replace our product/story containers
  let noResultsContainer = document.querySelector('.search-results__empty');
  if (!noResultsContainer) {
    noResultsContainer = document.createElement('div');
    noResultsContainer.className = 'search-results__empty';
    noResultsContainer.setAttribute('aria-hidden', 'true');
    resultsContent.appendChild(noResultsContainer);
  }
  
  // Storefront API settings
  const STOREFRONT_ACCESS_TOKEN = '76249782dd572514a4ca845b94d77d7d';
  const SHOP_DOMAIN = window.Shopify?.shop || window.location.hostname;
  
  // Cache for recently viewed products - store DOM elements
  let recentlyViewedCache = {
    productElements: null, // Will store DOM elements
    initialized: false
  };
  
  // Prefetch recently viewed products when page loads
  prefetchRecentlyViewed();
  
  // Show/hide search modal
  searchToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      openSearchModal();
    });
  });
  
  searchClose.addEventListener('click', function() {
    closeSearchModal();
  });
  
  // Close when clicking on the blur element
  if (headerBlur) {
    headerBlur.addEventListener('click', function() {
      if (searchModal.getAttribute('aria-hidden') === 'false') {
        closeSearchModal();
      }
    });
  }
  
  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchModal.getAttribute('aria-hidden') === 'false') {
      closeSearchModal();
    }
  });
  
  // Close if clicked outside content
  searchModal.addEventListener('click', function(e) {
    if (e.target === searchModal) {
      closeSearchModal();
    }
  });
  
  // Handle search input
  searchInput.addEventListener('input', debounce(function() {
    const searchTerm = this.value.trim();
    
    if (searchTerm.length < 2) {
      showInitialContent();
      return;
    }
    
    performSearch(searchTerm);
  }, 300));
  
  // Prefetch recently viewed products data and create DOM elements
  async function prefetchRecentlyViewed() {
    // Check if we have recently viewed products
    let recentlyViewedHandles = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
    if (recentlyViewedHandles.length === 0) return;
    
    // Get current product handle to exclude it
    const currentProductHandle = getCurrentProductHandle();
    
    // Filter out current product
    if (currentProductHandle) {
      recentlyViewedHandles = recentlyViewedHandles.filter(handle => handle !== currentProductHandle);
    }

    // Get first 4 product handles
    const productHandles = recentlyViewedHandles.slice(0, 4);
    
    if (productHandles.length === 0) return;
    
    try {
      // Fetch all products in parallel using Shopify's product.js endpoint
      const productPromises = productHandles.map(handle => 
        fetch(`${window.Shopify.routes.root}products/${handle}.js`)
          .then(response => response.json())
          .catch(error => {
            console.error(`Failed to prefetch product ${handle}:`, error);
            return null;
          })
      );
      
      const products = await Promise.all(productPromises);
      const validProducts = products.filter(p => p !== null);
      
      if (validProducts.length === 0) return;
      
      // Create a document fragment to build the product cards
      const fragment = document.createDocumentFragment();
      
      // Create product cards and add them to the fragment
      for (const product of validProducts) {
        const productCard = createProductCard(product);
        fragment.appendChild(productCard);
      }
      
      // Store the fragment in the cache
      recentlyViewedCache = {
        productElements: fragment,
        initialized: true
      };
      
      // Pre-initialize Swiper for product galleries
      if (window.Swiper) {
        const swipers = fragment.querySelectorAll('.card-product__gallery.swiper');
        if (swipers.length > 0) {
          // Create an invisible container to temporarily hold the elements
          // so Swiper can properly initialize
          const tempContainer = document.createElement('div');
          tempContainer.style.position = 'absolute';
          tempContainer.style.visibility = 'hidden';
          tempContainer.style.left = '-9999px';
          document.body.appendChild(tempContainer);
          
          // Clone the fragment to the temp container
          tempContainer.appendChild(fragment.cloneNode(true));
          
          // Initialize Swiper instances
          tempContainer.querySelectorAll('.card-product__gallery.swiper').forEach(el => {
            new Swiper(el, {
              pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true
              }
            });
          });
          
          // Clean up
          document.body.removeChild(tempContainer);
        }
      }
    } catch (error) {
      console.error('Error prefetching recently viewed products:', error);
    }
  }
  
  function openSearchModal() {
    searchModal.setAttribute('aria-hidden', 'false');
    searchToggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'true');
    });


    // Close mobile nav if open
    const mobileNav = document.querySelector('.header-sidebar-nav');
    if (mobileNav && mobileNav.classList.contains('active')) {
      mobileNav.classList.remove('active');
      const mobileHeaderToggle = document.querySelector('.header__menu-mobile-toggle');
      if (mobileHeaderToggle) {
        mobileHeaderToggle.classList.remove('header__menu-mobile-toggle--open');
      }
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overlay-open');
      document.body.classList.remove('overlay-open--left');
    }
    
    // Add class to body to prevent scrolling (reusable for cart and sidebar)
    document.body.classList.add('search-modal-open');
    document.body.classList.add('modal-open'); // Generic class for all modals
    
    // Use cached recently viewed products if available
    if (recentlyViewedCache.initialized && recentlyViewedCache.productElements) {
      const container = document.querySelector('.search-results__recently-viewed-container');
      if (container) {
        // Clear container first
        container.innerHTML = '';
        
        // Clone the cached elements and append to container
        const clonedElements = recentlyViewedCache.productElements.cloneNode(true);
        container.appendChild(clonedElements);
        
        // Re-initialize Swiper for the cloned elements
        if (window.Swiper) {
          const swipers = container.querySelectorAll('.card-product__gallery.swiper');
          swipers.forEach(el => {
            new Swiper(el, {
              pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true
              }
            });
          });
        }
        
        // Initialize quick add buttons if needed
        if (window.initQuickAddButtons) {
          window.initQuickAddButtons(container);
        }
      }
    } else {
      // If not initialized yet, load them now
      loadRecentlyViewedProducts();
    }
    
    setTimeout(() => searchInput.focus(), 100);
  }
  
  function closeSearchModal() {
    searchModal.setAttribute('aria-hidden', 'true');
    searchToggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    
    // Remove classes that prevent scrolling
    document.body.classList.remove('search-modal-open');
    document.body.classList.remove('modal-open');
    
    // Wait until modal is out of view before resetting content
    setTimeout(() => {
      searchInput.value = '';
      showInitialContent();
    }, MODAL_TRANSITION_DURATION);
  }
  
  function showInitialContent() {
    initialContent.setAttribute('aria-hidden', 'false');
    resultsContent.setAttribute('aria-hidden', 'true');
    // document.querySelector('.search-page__content').setAttribute('aria-hidden', 'true');
    loadingElement.setAttribute('aria-hidden', 'true');
    
    // Ensure no results message is hidden
    if (noResultsContainer) {
      noResultsContainer.setAttribute('aria-hidden', 'true');
    }
  }
  
  function showLoadingState() {
    initialContent.setAttribute('aria-hidden', 'true');
    resultsContent.setAttribute('aria-hidden', 'true');
    // document.querySelector('.search-page__content').setAttribute('aria-hidden', 'true');
    // loadingElement.setAttribute('aria-hidden', 'false');
    
    // Ensure no results message is hidden
    if (noResultsContainer) {
      noResultsContainer.setAttribute('aria-hidden', 'true');
    }
  }
  
  function showResults() {
    initialContent.setAttribute('aria-hidden', 'true');
    resultsContent.setAttribute('aria-hidden', 'false');
    // document.querySelector('.search-page__content').setAttribute('aria-hidden', 'false');
    loadingElement.setAttribute('aria-hidden', 'true');
    
    // Explicitly hide the no results container when showing results
    if (noResultsContainer) {
      noResultsContainer.setAttribute('aria-hidden', 'true');
    }
  }
  
  // Function to load recently viewed products (fallback if cache not ready)
  async function loadRecentlyViewedProducts() {
    const container = document.querySelector('.search-results__recently-viewed-container');
    if (!container) return;

    // Get recently viewed products from localStorage
    let recentlyViewed = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
    
    if (recentlyViewed.length === 0) {
      container.innerHTML = `<p class="empty-state">${TRANSLATIONS.product.recently_viewed.empty}</p>`;
      return;
    }
    
    // Get current product handle to exclude it
    const currentProductHandle = getCurrentProductHandle();
    
    // Filter out current product
    if (currentProductHandle) {
      recentlyViewed = recentlyViewed.filter(handle => handle !== currentProductHandle);
    }

    // Get first 4 product handles
    const productHandles = recentlyViewed.slice(0, 4);
    
    if (productHandles.length === 0) {
      container.innerHTML = `<p class="empty-state">${TRANSLATIONS.search.no_recently_viewed}</p>`;
      return;
    }
    
    try {
      container.innerHTML = `<p class="loading">${TRANSLATIONS.search.loading_products}</p>`;
      
      // Fetch all products in parallel
      const productPromises = productHandles.map(handle => 
        fetch(`${window.Shopify.routes.root}products/${handle}.js`)
          .then(response => response.json())
          .catch(error => {
            console.error(`Failed to fetch product ${handle}:`, error);
            return null;
          })
      );
      
      const products = await Promise.all(productPromises);
      const validProducts = products.filter(p => p !== null);
      
      if (validProducts.length > 0) {
        // Create a document fragment for better performance
        const fragment = document.createDocumentFragment();
        
        for (const product of validProducts) {
          const productCard = createProductCard(product);
          fragment.appendChild(productCard);
        }
        
        // Update cache with the fragment
        recentlyViewedCache = {
          productElements: fragment.cloneNode(true),
          initialized: true
        };
        
        // Clear container and append the fragment
        container.innerHTML = '';
        container.appendChild(fragment);
        
        // Initialize Swiper for product galleries
        if (window.Swiper) {
          const swipers = container.querySelectorAll('.card-product__gallery.swiper');
          swipers.forEach(el => {
            new Swiper(el, {
              pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true
              }
            });
          });
        }
        
        // Initialize quick add buttons if the function exists
        if (window.initQuickAddButtons) {
          window.initQuickAddButtons(container);
        }
      } else {
        container.innerHTML = `<p class="empty-state">${TRANSLATIONS.search.no_products_found}</p>`;
      }
    } catch (error) {
      console.error('Error loading recently viewed products:', error);
      container.innerHTML = `<p class="empty-state">${TRANSLATIONS.search.unable_to_load_recently_viewed}</p>`;
    }
  }
  
  // Function to create product card DOM element
  function createProductCard(product) {
    // Create main card element
    const cardElement = document.createElement('div');
    cardElement.className = `card-product search-results__product${product.type === "Opticals" ? " card-product--opticals" : ""}${product.type === "Watch" ? " card-product--watch" : ""}${product.type === "Jewelry" ? " card-product--jewelry" : ""}${product.tags.includes("coming-soon") ? " card-product--coming-soon" : ""}`;
    cardElement.setAttribute('data-product-card', '');
    
    // Product media
    const mediaLink = document.createElement('a');
    mediaLink.href = `/products/${product.handle}`;
    mediaLink.className = 'card-product__media';
    
    if (product.images && product.images.length > 0) {
      // Create gallery
      const gallery = document.createElement('div');
      gallery.className = 'card-product__gallery swiper';
      
      // First image section (featured image or shot on face)
      const firstImageContainer = document.createElement('div');
      firstImageContainer.className = 'card-product__gallery--first';
      
      const firstImg = document.createElement('img');
      // Use featured media or first image if media array not available
      const mediaSource = product.media && product.media.length > 0 ? 
                        product.media[0].src : 
                        product.featured_image?.src || product.images[0].src;

      // console.log('media source', mediaSource);
      
      firstImg.src = mediaSource;
      firstImg.alt = product.title;
      firstImg.className = 'card-product__gallery--first-image first-image--product';
      firstImg.loading = 'lazy';
      
      // Try to get shot_on_face metafield if available
      const shotOnFace = null;
      
      firstImageContainer.appendChild(firstImg);
      gallery.appendChild(firstImageContainer);
      
      // Create swiper wrapper for additional images
      const swiperWrapper = document.createElement('div');
      swiperWrapper.className = 'swiper-wrapper';
      
      // Skip first image if using shot_on_face
      const startIndex = shotOnFace ? 0 : 1;
      
      for (let i = startIndex; i < product.images.length; i++) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        
        const img = document.createElement('img');
        img.src = product.images[i].src || product.images[i];
        img.alt = product.title;
        img.className = 'card-product__image';
        
        // Add special class for second image if shot_on_face is used
        if (i === 1 && shotOnFace) {
          img.classList.add('card-product__image-second-contain');
        }
        
        img.loading = 'lazy';
        
        slide.appendChild(img);
        swiperWrapper.appendChild(slide);
      }
      
      gallery.appendChild(swiperWrapper);
      
      // Add pagination if multiple images
      if (product.images.length > 1) {
        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        gallery.appendChild(pagination);
      }
      
      mediaLink.appendChild(gallery);
    } else {
      // No media placeholder
      const noMedia = document.createElement('div');
      noMedia.className = 'card-product__no-media';
      noMedia.innerHTML = `<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.5-1.3-2.8-2.9-2.8zm.1 95.3H203.1v-92.5h121.6v92.5z"/><path d="M210.4 299.5H239c1.6 0 2.8-1.3 2.8-2.8v-59.9c0-1.6-1.3-2.8-2.8-2.8h-28.6c-1.6 0-2.8 1.3-2.8 2.8v59.9c0 1.5 1.3 2.8 2.8 2.8zm2.8-59.9h23v54.3h-23v-54.3zM309.1 236.8h-28.6c-1.6 0-2.8 1.3-2.8 2.8v28.6c0 1.6 1.3 2.8 2.8 2.8h28.6c1.6 0 2.8-1.3 2.8-2.8v-28.6c.1-1.6-1.2-2.8-2.8-2.8zm-2.7 28.6h-23v-23h23v23z"/></svg>`;
      mediaLink.appendChild(noMedia);
    }

    const badgeElement = createProductBadge(product);
    if (badgeElement) {
      mediaLink.appendChild(badgeElement);
    }
    
    // Favorite button with correct SVG
    const favorite = document.createElement('button');
    favorite.setAttribute('onclick', `toggleFavorite('${product.handle}', this, '${product.title}' );`);
    favorite.className = 'card-product__favorite';
    favorite.innerHTML = `
      <svg class="icon icon-heart" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path d="M8 4.7905L7.29375 4.08425L6.53438 3.32488C5.92813 2.7155 5.10313 2.37488 4.24375 2.37488C2.45313 2.37488 1 3.828 1 5.61863C1 6.478 1.34063 7.303 1.95 7.91238L2.70625 8.66863L8 13.9624L13.2937 8.66863L14.05 7.91238C14.6594 7.303 15 6.478 15 5.61863C15 3.828 13.5469 2.37488 11.7563 2.37488C10.8969 2.37488 10.0719 2.7155 9.4625 3.32488L8.70625 4.08113L8 4.7905ZM8.70625 14.6686L8 15.3749L7.29375 14.6686L2 9.37488L1.24375 8.61863C0.446875 7.82175 0 6.74363 0 5.61863C0 3.27488 1.9 1.37488 4.24375 1.37488C5.36875 1.37488 6.44688 1.82175 7.24375 2.61863L7.29375 2.66863L8 3.37488L8.70625 2.66863L8.75625 2.61863C9.55313 1.82175 10.6313 1.37488 11.7563 1.37488C14.1 1.37488 16 3.27488 16 5.61863C16 6.74363 15.5531 7.82175 14.7563 8.61863L14 9.37488L8.70625 14.6686Z" fill="inherit"></path>
        <path class="icon-heart-fill-layer" d="M8.70625 14.6686L8 15.3749L7.29375 14.6686L2 9.37488L1.24375 8.61863C0.446875 7.82175 0 6.74363 0 5.61863C0 3.27488 1.9 1.37488 4.24375 1.37488C5.36875 1.37488 6.44688 1.82175 7.24375 2.61863L7.29375 2.66863L8 3.37488L8.70625 2.66863L8.75625 2.61863C9.55313 1.82175 10.6313 1.37488 11.7563 1.37488C14.1 1.37488 16 3.27488 16 5.61863C16 6.74363 15.5531 7.82175 14.7563 8.61863L14 9.37488L8.70625 14.6686Z" fill="none"></path>
      </svg>
    `;
    
    // Product info section
    const info = document.createElement('div');
    info.className = 'card-product__info';
    
    // Product title
    const title = document.createElement('a');
    title.href = `/products/${product.handle}`;
    title.className = 'card-product__title card-product__link';
    title.textContent = product.title;
    
    // Product price
    const priceContainer = document.createElement('div');
    priceContainer.className = 'card-product__price';
    
    const showPriceOnComingSoon = window.showComingSoonPrices || false;
    // console.log('showPriceOnComingSoon', showPriceOnComingSoon, window.showComingSoonPrices);
    const isComingSoon = product.tags?.includes('coming-soon');

    // Only add price if not opticals or coming soon with setting enabled
    if (isComingSoon) {
      if(showPriceOnComingSoon) {
        const priceInner = document.createElement('div');
        priceInner.className = `card-product__price-inner price${product.compare_at_price > product.price ? ' price--on-sale' : ''}`;
        
        let priceHTML = '';
        
        // Add original price if on sale
        if (product.compare_at_price > product.price) {
          priceHTML += `<span class="price__original" aria-hidden="true">${formatMoney(product.compare_at_price)}</span>`;
          priceHTML += `<span class="visually-hidden">Regular price</span>`;
        }
        
        // Current price
        priceHTML += `<span class="price__current">${formatMoney(product.price)}</span>`;
        
        // Sale price label and savings if on sale
        if (product.compare_at_price > product.price) {
          priceHTML += `<span class="visually-hidden">${TRANSLATIONS.product.sale_price}</span>`;
          priceHTML += `<span class="price__savings">${TRANSLATIONS.product.save_amount} ${formatMoney(product.compare_at_price - product.price)}</span>`;
        }
        
        priceInner.innerHTML = priceHTML;
        priceContainer.appendChild(priceInner);
      }
    } else if (product.type !== "Opticals") {
      const priceInner = document.createElement('div');
      priceInner.className = `card-product__price-inner price${product.compare_at_price > product.price ? ' price--on-sale' : ''}`;
      
      let priceHTML = '';
      
      // Add original price if on sale
      if (product.compare_at_price > product.price) {
        priceHTML += `<span class="price__original" aria-hidden="true">${formatMoney(product.compare_at_price)}</span>`;
        priceHTML += `<span class="visually-hidden">Regular price</span>`;
      }
      
      // Current price
      priceHTML += `<span class="price__current">${formatMoney(product.price)}</span>`;
      
      // Sale price label and savings if on sale
      if (product.compare_at_price > product.price) {
        priceHTML += `<span class="visually-hidden">${TRANSLATIONS.product.sale_price}</span>`;
        priceHTML += `<span class="price__savings">${TRANSLATIONS.product.save_amount} ${formatMoney(product.compare_at_price - product.price)}</span>`;
      }
      
      priceInner.innerHTML = priceHTML;
      priceContainer.appendChild(priceInner);
    }
    
    // Add elements to info container
    info.appendChild(title);
    info.appendChild(priceContainer);
    
    // Quick add button (if product is available and not coming soon)
    if (product.available && !isComingSoon && product.type !== "Opticals") {
      const quickAdd = document.createElement('div');
      quickAdd.setAttribute('role', 'button');
      quickAdd.className = 'card-product__quick-add';
      quickAdd.setAttribute('data-quick-add', '');
      quickAdd.setAttribute('data-product-id', product.id);
      quickAdd.setAttribute('data-variant-id', product.variants[0].id);
      quickAdd.innerHTML = `
        <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
          <path class="icon-plus__horizontal" d="M7.42746 8.55261H1.14174H0.570312V9.69296H1.14174H7.42746H8.57031H14.856H15.4275V8.55261H14.856H8.57031H7.42746Z" fill="inherit"></path>
          <path class="icon-plus__vertical" d="M8.57031 8.55136L8.57031 2.26564L8.57031 1.69421L7.42996 1.69421L7.42996 2.26564L7.42996 8.55136L7.42996 9.69421L7.42996 15.9799L7.42996 16.5514L8.57031 16.5514L8.57031 15.9799L8.57031 9.69421L8.57031 8.55136Z" fill="inherit"></path>
        </svg>
      `;
      info.appendChild(quickAdd);
    }
    
    // Add all sections to card
    cardElement.appendChild(mediaLink);
    cardElement.appendChild(favorite);
    cardElement.appendChild(info);
    
    return cardElement;
  }

  function createProductBadge(product) {
    let badgeToShow = "";
    
    // Get settings from window.theme
    const showPriceOnOpticals = window.theme?.settings?.show_price_on_opticals || false;
    const seasonalBadgeTag = window.theme?.settings?.product_tag_seasonal_current || '';
    const seasonalBadgeText = window.theme?.settings?.product_badge_seasonal_current || '';
    const seasonalBadgeIcon = window.theme?.settings?.product_badge_seasonal_icon || '';
    const nextBadgeIcon = window.theme?.settings?.product_badge_next || '';
    const lowStockThreshold = window.theme?.settings?.low_stock_threshold || 10;
    
    // Check if product is low in stock
    const isLowStock = product.variants?.some(variant => 
      variant.inventory_quantity !== null && 
      variant.inventory_quantity > 0 && 
      variant.inventory_quantity <= lowStockThreshold
    );

    const isComingSoon = product.tags?.includes('coming-soon');

    // console.log('Product:', product);
    // console.log('Is Low Stock:', isLowStock);
    
    // Determine which badge to show (similar logic to the Liquid snippet)
    if (showPriceOnOpticals) {
      if (isComingSoon) {
        badgeToShow = "Coming Soon";
      } else if (!product.available) {
        badgeToShow = "Notify";
      } else if (product.metafields?.custom?.badge) {
        badgeToShow = "Custom";
      } else if (isLowStock) {
        badgeToShow = "LowStock";
      } else if (product.type === "Opticals") {
        badgeToShow = "Optical";
      } else if (product.tags?.includes(seasonalBadgeTag) && seasonalBadgeText) {
        badgeToShow = "Odyssey";
      } else if (product.tags?.includes("filter-NEXT")) {
        badgeToShow = "Next";
      }
    } else {
      if (isComingSoon) {
        badgeToShow = "Coming Soon";
      } else if (product.type === "Opticals") {
        badgeToShow = "Optical";
      } else if (!product.available) {
        badgeToShow = "Notify";
      } else if (product.metafields?.custom?.badge) {
        badgeToShow = "Custom";
      } else if (isLowStock) {
        badgeToShow = "LowStock";
      } else if (product.tags?.includes(seasonalBadgeTag) && seasonalBadgeText) {
        badgeToShow = "Odyssey";
      } else if (product.tags?.includes("filter-NEXT")) {
        badgeToShow = "Next";
      }
    }
    
    if (!badgeToShow) return null;
    
    // Create badge element
    const badgeElement = document.createElement('div');
    badgeElement.className = `product__badge${badgeToShow === "Next" ? " product__badge--next" : ""}${badgeToShow === "Notify" ? " product__badge--notify" : ""}${badgeToShow === "Coming Soon" ? " product__badge--notify" : ""}${badgeToShow === "LowStock" ? " product__badge--low-stock" : ""}`;
    
    let badgeHTML = '';
    
    switch (badgeToShow) {
      case "Coming Soon":
        badgeHTML = `<span class="badge badge--notify">${TRANSLATIONS.product.coming_soon}</span>`;
        break;
      case "Notify":
        badgeHTML = `<span class="badge badge--notify">${TRANSLATIONS.product.notify_me}</span>`;
        break;
      case "Optical":
        badgeHTML = `<span class="badge badge--optical">${TRANSLATIONS.product.optical}</span>`;
        break;
      case "LowStock":
        badgeHTML = `<span class="badge badge--low-stock">${TRANSLATIONS.product.low_in_stock}</span>`;
        break;
      case "Odyssey":
        if (seasonalBadgeIcon) {
          badgeHTML = `<span class="badge__icon"><img src="${seasonalBadgeIcon}" class="badge__image" loading="eager" alt=""></span>`;
        }
        badgeHTML += `<span class="badge badge--odyssey">${seasonalBadgeText || 'Odyssey'}</span>`;
        break;
      case "Next":
        if (nextBadgeIcon) {
          badgeHTML = `<span class="badge__icon badge__icon--next"><img src="${nextBadgeIcon}" class="badge__image" loading="eager" alt=""></span>`;
        } else {
          badgeHTML = '<span class="badge badge--next">KOMONO NEXT</span>';
        }
        break;
      case "Custom":
        badgeHTML = `<span class="badge badge--custom">${product.metafields.custom.badge}</span>`;
        break;
      default:
        badgeHTML = `<span class="badge">${badgeToShow}</span>`;
    }
    
    badgeElement.innerHTML = badgeHTML;
    return badgeElement;
  }
  
  // Function to create story card DOM element
  function createStoryCard(story) {
    const storyCard = document.createElement('a');
    storyCard.href = story.url || `/pages/${story.handle}`;
    storyCard.className = 'story-card';
    
    storyCard.innerHTML = `
      <div class="story-card__image">
        <img src="${story.featuredImage || '/assets/placeholder-story.jpg'}" alt="${story.title}">
      </div>
      <h3 class="story-card__title h4">${story.title}</h3>
    `;
    
    return storyCard;
  }
  
  // New combined search function using Storefront API for both products and stories
  async function performSearch(term) {
    showLoadingState();
    
    try {
      // Fetch search results using Storefront API
      const searchResults = await searchStorefrontAPI(term);
      
      // Reset containers for new results
      productsContainer.innerHTML = '';
      storiesContainer.innerHTML = '';
      
      // ALWAYS hide no results container before checking if we need to show it
      if (noResultsContainer) {
        noResultsContainer.setAttribute('aria-hidden', 'true');
        noResultsContainer.style.display = 'none';
      }
      
      // Render products if there are any
      if (searchResults.products.length > 0) {
        renderProductResults(searchResults.products, term, searchResults.totalProductCount);
      }
      
      // Render stories if there are any
      if (searchResults.stories.length > 0) {
        renderStoryResults(searchResults.stories, term);
      }
      
      // Show no results message if needed
      if (searchResults.products.length === 0 && searchResults.stories.length === 0) {
        showNoResults(term);
      }
      
      showResults();
    } catch (error) {
      console.error('Search error:', error);
      showInitialContent();
    }
  }
  
  // Unified search function using Storefront API for both products and stories
  async function searchStorefrontAPI(term) {
    try {
      // GraphQL query that searches both products and pages
      const graphqlQuery = {
        query: `
          query Search($searchTerm: String!, $productsFirst: Int!, $pagesFirst: Int!) {
            products(first: $productsFirst, query: "title:*${term}* OR tag:*${term}* OR product_type:*${term}* OR vendor:*${term}*", sortKey: RELEVANCE, reverse: true) {
              edges {
                node {
                  id
                  title
                  handle
                  description
                  productType
                  tags
                  availableForSale
                  vendor
                  onlineStoreUrl
                  
                  priceRange {
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                  
                  images(first: 5) {
                    edges {
                      node {
                        url
                        altText
                        width
                        height
                      }
                    }
                  }
                  
                  variants(first: 1) {
                    edges {
                      node {
                        id
                        title
                        availableForSale
                        price {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                  
                  badgeMetafield: metafield(namespace: "custom", key: "badge") {
                    value
                  }
                  
                  shotOnFaceMetafield: metafield(namespace: "custom", key: "shot_on_face") {
                    value
                  }
                }
              }
            }
            
            pages(first: $pagesFirst, query: $searchTerm) {
              edges {
                node {
                  id
                  title
                  handle
                  onlineStoreUrl
                  
                  isLanding: metafield(namespace: "theme", key: "is_landing_page") {
                    value
                  }
                  
                  featured: metafield(namespace: "theme", key: "landing_page_featured_image_video") {
                    value
                    reference {
                      ... on MediaImage {
                        image {
                          url
                          altText
                        }
                      }
                      ... on GenericFile {
                        url
                      }
                      ... on Video {
                        sources {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          searchTerm: term,
          productsFirst: 50,
          pagesFirst: 6
        }
      };
      
      const response = await fetch(`https://${SHOP_DOMAIN}/api/2025-07/graphql.json`, {
        method: 'POST',
        headers: {
          "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(graphqlQuery)
      });
      
      const responseData = await response.json();
      
      if (!responseData.data) {
        console.error('Invalid Storefront API response:', responseData);
        return { products: [], stories: [] };
      }
      
      // Process product results
      const allProducts = responseData.data.products.edges
        .filter(({ node }) => node.onlineStoreUrl !== null)
        .map(({ node }) => {
        // Convert Storefront API product to the format expected by createProductCard
        const productTags = node.tags || [];
        
        // Convert Shopify Storefront API images to format expected by createProductCard
        const images = node.images.edges.map(edge => ({
          src: edge.node.url,
          alt: edge.node.altText || node.title
        }));
        
        // Get the first variant
        const firstVariant = node.variants.edges[0]?.node;
        
        return {
          id: node.id.split('/').pop(), // Extract the numeric ID from the Shopify GraphQL ID
          title: node.title,
          handle: node.handle,
          description: node.description,
          type: node.productType,
          tags: productTags,
          available: node.availableForSale,
          vendor: node.vendor,
          price: parseFloat(node.priceRange.minVariantPrice.amount) * 100, // Convert to cents
          featured_image: { src: images[0]?.src },
          images: images,
          metafields: {
            custom: {
              badge: node.badgeMetafield?.value,
              shot_on_face: node.shotOnFaceMetafield?.value
            }
          },
          variants: [{
            id: firstVariant?.id.split('/').pop(),
            title: firstVariant?.title,
            available: firstVariant?.availableForSale,
            price: parseFloat(firstVariant?.price.amount) * 100
          }]
        };
      });

      const totalProductCount = allProducts.length;

      const products = allProducts.slice(0, 6);
      
      // Process story results - only include pages that are marked as landing pages (stories)
      const isTrue = v => (typeof v === 'string' ? v.toLowerCase() : v) === 'true' || v === '1' || v === true;
      
      const stories = responseData.data.pages.edges
        .map(({ node }) => {
          // Skip if not marked as a landing page
          if (!node.isLanding || !isTrue(node.isLanding.value)) {
            return null;
          }
          
          // Get the featured image URL
          let featuredImage = null;

          // console.log(node.featured);
          
          if (node.featured) {
            // Try to get image URL from reference
            if (node.featured.reference) {
              if (node.featured.reference.image) {
                featuredImage = node.featured.reference.image.url;
              } else if (node.featured.reference.sources && 
                        node.featured.reference.sources.length) {
                featuredImage = node.featured.reference.sources[0].url;
              }
            }
            
            // If no reference URL found, use the value as fallback
            if (!featuredImage && node.featured.value) {
              featuredImage = node.featured.value;
            }
          }
          
          return {
            id: node.id,
            title: node.title,
            handle: node.handle,
            url: node.onlineStoreUrl || `/pages/${node.handle}`,
            featuredImage: featuredImage
          };
        })
        .filter(page => page !== null);
      
      return { products, stories, totalProductCount };
    } catch (error) {
      console.error('Error with Storefront API search:', error);
      return { products: [], stories: [], totalProductCount: 0 };
    }
  }
  
  // Render product results
  function renderProductResults(products, term, totalProductCount) {
    if (products.length === 0) {
      return;
    }
    
    productsContainer.innerHTML = `<h2 class="search-results__title h3">${TRANSLATIONS.search.products}</h2><div class="search-results__grid"></div>`;
    const productsGrid = productsContainer.querySelector('.search-results__grid');
    
    // Create a document fragment for better performance
    const fragment = document.createDocumentFragment();
    
    for (const product of products) {
      const productCard = createProductCard(product);
      fragment.appendChild(productCard);
    }
    
    // Add all products at once
    productsGrid.appendChild(fragment);
    
    // Initialize Swiper for product galleries
    if (window.Swiper) {
      const swipers = productsGrid.querySelectorAll('.card-product__gallery.swiper');
      swipers.forEach(el => {
        new Swiper(el, {
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true
          }
        });
      });
    }
    
    // Initialize quick add buttons if the function exists
    if (window.initQuickAddButtons) {
      window.initQuickAddButtons(productsGrid);
    }
    
    // Add "See all" link if we have maximum results
    if (totalProductCount > 6) {
      const seeAllLink = document.createElement('a');
      seeAllLink.href = `/search?q=${encodeURIComponent(term)}&type=product`;
      seeAllLink.className = 'search-results__see-all button button--secondary';
      seeAllLink.textContent = `${TRANSLATIONS.search.see_all_for} '${term}'`;
      productsContainer.appendChild(seeAllLink);
    }
  }
  
  // Render story results
  function renderStoryResults(stories, term) {
    if (stories.length === 0) {
      return;
    }
    
    storiesContainer.innerHTML = `<h2 class="search-results__title h3">${TRANSLATIONS.search.stories}</h2><div class="search-results__grid"></div>`;
    const storiesGrid = storiesContainer.querySelector('.search-results__grid');
    
    // Create a document fragment for better performance
    const fragment = document.createDocumentFragment();
    
    for (const story of stories) {
      const storyCard = createStoryCard(story);
      fragment.appendChild(storyCard);
    }
    
    // Add all stories at once
    storiesGrid.appendChild(fragment);
    
    // Add "See all" link if we have maximum results
    if (stories.length === 6) {
      const seeAllLink = document.createElement('a');
      seeAllLink.href = `/search?q=${encodeURIComponent(term)}&type=page`;
      seeAllLink.className = 'search-results__see-all';
      seeAllLink.textContent = `${TRANSLATIONS.search.see_all_for} "${term}"`;
      storiesContainer.appendChild(seeAllLink);
    }
  }
  
  // Show no results message
  function showNoResults(term) {
    noResultsContainer.innerHTML = `
      <div class="search-results__empty-content">
        <h2 class="search-results__title h3">${TRANSLATIONS.search.we_didnt_find_anything_for} "${term}"</h2>
        <p>${TRANSLATIONS.search.please_try_another_search}</p>
        <a href="${ collectionSearchUrl }" class="button button--secondary">${TRANSLATIONS.search.discover_our_new_arrivals}</a>
      </div>
    `;
    noResultsContainer.setAttribute('aria-hidden', 'false');
    noResultsContainer.style.display = 'block'; // Add explicit style showing
  }
  
  // Helper function to get current product handle
  function getCurrentProductHandle() {
    // Try to get from canonical link
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      const url = new URL(canonicalLink.href);
      const pathParts = url.pathname.split('/');
      if (pathParts.includes('products') && pathParts.length > 2) {
        const index = pathParts.indexOf('products');
        return pathParts[index + 1];
      }
    }
    
    // Try to get from current URL if on product page
    if (window.location.pathname.includes('/products/')) {
      const pathParts = window.location.pathname.split('/');
      const index = pathParts.indexOf('products');
      return pathParts[index + 1];
    }
    
    return null;
  }
  
  // Helper: Format money
  function formatMoney(cents, format) {
    // Use passed format, or global MONEY_FORMAT, or fallback to Euro format
    format = format || MONEY_FORMAT || '€';
    
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    // Convert to number if not already
    cents = parseInt(cents) || 0;
    
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    
    function formatWithDelimiters(number, precision) {
      precision = precision || 2;
      number = (number / 100.0).toFixed(precision);
      return number.replace('.', '.');
    }

    const match = format.match(placeholderRegex);
    if (!match) {
      // Fallback if no placeholder found
      return `€${formatWithDelimiters(cents, 2)}`;
    }
    
    switch(match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2).replace(',', ' ');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    
    return format.replace(placeholderRegex, value);
  }
  
  // Helper: Debounce function
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }
});